export const FLAT_SALE_REASONS = [
  'Квартира ещё продается?',
  'Как добраться от метро?',
  'Что есть поблизости?',
  'Где рядом можно отдохнуть?',
  'Сможете снизить цену?',
];
